import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const FloatingInput = React.forwardRef((props, ref) => {
  const {
    name,
    label,
    containerClassName,
    labelClassName,
    required,
    type,
    error,
    isLowerCase,
    ...rest
  } = props;

  const handleOnFocus = (e) => {
    e.preventDefault();
    document.getElementById(_.get(rest, "id") || name).focus();
  };

  const renderClassName = () => {
    if (isLowerCase) {
      return "";
    }
    if (type === "email") {
      return "";
    }
    return "uppercase";
  };

  return (
    <div className="flex flex-col w-full relative">
      <div
        className={containerClassName}
        onClick={handleOnFocus}
        ref={ref}
        role="presentation"
      >
        <input
          id={_.get(rest, "id") || name}
          type={type}
          autoComplete="chrome-off"
          placeholder={label}
          className={`floating-input ${renderClassName()}`}
          {...rest}
        />
        <label className={labelClassName} htmlFor={_.get(rest, "id") || name}>
          {label} {required ? <span className="text-red-500">*</span> : ""}
        </label>
      </div>
      {error && (
        <small className="flex text-xxs absolute bottom-2 items-center gap-1 right-0 px-2 bg-red-50 rounded text-red-500">
          <i className="fa fa-exclamation-circle" /> {error?.message ?? ""}
        </small>
      )}
    </div>
  );
});

FloatingInput.defaultProps = {
  label: "Name",
  containerClassName: "floating-form",
  labelClassName: "floating-label",
  required: false,
  type: "text",
  error: false,
  isLowerCase: false,
};

FloatingInput.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.bool,
  ]),
  name: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Object),
    PropTypes.bool,
  ]),
  isLowerCase: PropTypes.bool,
};

export default React.memo(FloatingInput);
